/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of Assets consolidated. The values can be ESS, MACHINE, CHARGER, CHARGING_STATION, ENERGY_SOURCE and GHOST. By Default it is MACHINE.
 *
 */
export var AssetSourceTypeConsolidated;
(function (AssetSourceTypeConsolidated) {
    AssetSourceTypeConsolidated["MACHINE"] = "MACHINE";
    AssetSourceTypeConsolidated["ESS"] = "ESS";
    AssetSourceTypeConsolidated["CHARGER"] = "CHARGER";
    AssetSourceTypeConsolidated["CHARGING_STATION"] = "CHARGING_STATION";
    AssetSourceTypeConsolidated["ENERGY_SOURCE"] = "ENERGY_SOURCE";
    AssetSourceTypeConsolidated["GHOST"] = "GHOST";
})(AssetSourceTypeConsolidated || (AssetSourceTypeConsolidated = {}));
